module.exports = __webpack_public_path__ + "img/80f1.99d9dcb6.jpg";